import React from 'react';

import AuthDesktop from '../AuthDesktop';
import AuthMobile from '../AuthMobile';

import styles from './AuthGeneric.module.scss';
import { isMobile } from 'helpers/Mobile';

export class AuthGeneric extends React.Component {
    
    render() {
        const {
            content,
            title,
            version,
            handleGoBack
        } = this.props;
        return (
            <div className={styles["auth-generic-container"]}>
                {!isMobile && <AuthDesktop content={content}></AuthDesktop>}
                {isMobile && <AuthMobile content={content} version={version} title={title} handleGoBack={handleGoBack}></AuthMobile>}
            </div>
        )
    }

}


AuthGeneric.propTypes = {
    
};

export default AuthGeneric;